import { usePictureSets } from "@/react/Webshop/hooks/usePictureSets";
import { usePriceList } from "@/react/Webshop/providers/PriceListProvider";
import { useShoppingCart } from "@/react/Webshop/providers/ShoppingCartProvider";
import React from "react";
import { Trans } from "react-i18next";
import { callAPI } from "@/react/lib/common";
import Grid from "@mui/material/Grid";
import EpmsImage from "@/react/components/Common/EpmsImage";
import { formatCurrency } from "@/react/utils";
import Button from "@mui/material/Button";
import CardActions from "@mui/material/CardActions";
import makeStyles from "@mui/styles/makeStyles";
import useDigitalRebate from "@/react/Webshop/hooks/useDigitalRebate";
const useStyles = makeStyles((theme) => ({
    card: {
        display: "flex",
        flexDirection: "column",
        marginBottom: theme.spacing(2),
    },
    imageContainer: {
        flexGrow: 1,
        padding: 0,
        "& img, & canvas": {
            width: "100%",
            border: `1px solid ${theme.palette.primary.light}`,
        },
    },
    oldPrice: {
        color: "rgba(0, 0, 0, 0.6)",
        textDecoration: "line-through",
    },
    currentPrice: {
        color: theme.palette.secondary.main,
        fontWeight: "bold",
    },
    singleFilePriceContainer: {},
    cardActions: {
        justifyContent: "space-between",
        paddingRight: 0,
        paddingLeft: 0,
    },
    buyCompleteSetContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(2),
    },
}));
function PictureSetPictures({ pictures, pictureSet, singleFileProduct, boughtImagesOfType, settings, type, }) {
    const classes = useStyles();
    const { update: updatePictureSets } = usePictureSets();
    const { updateCart, qualifyForDigitalRebate } = useShoppingCart();
    const { getPricePerUnit } = usePriceList();
    const { getRebatedFilePriceByType } = useDigitalRebate();
    let priceWithOneMoreItem = 0;
    let priceWithOneMoreCampaignItem = 0;
    const hasCampaignPrice = !!(singleFileProduct === null || singleFileProduct === void 0 ? void 0 : singleFileProduct.productprices[0].campaignprice);
    if (singleFileProduct) {
        console.log("Single file product", singleFileProduct, boughtImagesOfType.length + 1);
        priceWithOneMoreItem = getPricePerUnit(singleFileProduct, boughtImagesOfType.length + 1, false);
        priceWithOneMoreCampaignItem = getPricePerUnit(singleFileProduct, boughtImagesOfType.length + 1, hasCampaignPrice);
    }
    const toggleFileInCart = (file) => {
        callAPI("/ajax/cart/toggle_digital_file_in_cart.php", "POST", {
            file: file.uuid,
            type,
        })
            .then((data) => {
            if (window.isEpmsAnalyticsFeatureEnabled && window.epmsAnalytics) {
                window.epmsAnalytics.onCartChange(data);
            }
            console.log("Toggle file", data);
            updatePictureSets().then(updateCart);
        })
            .catch((err) => {
            console.log("Toggle digital file", err);
        });
    };
    const shouldShowBuySingleFileActions = !!singleFileProduct;
    const rebatedFilePrice = getRebatedFilePriceByType(type);
    const doQualifyForDigitalRebate = singleFileProduct && qualifyForDigitalRebate && rebatedFilePrice !== null;
    const pictureSetInCart = settings.getSetIsInCart(pictureSet);
    return (React.createElement(Grid, { container: true, spacing: 3 }, pictures.map((picture) => {
        return (React.createElement(Grid, { size: { xs: 12, sm: 6, md: 4 }, className: classes.card, key: `${picture.uuid}` },
            React.createElement("div", { className: classes.imageContainer },
                React.createElement(EpmsImage, { uuid: picture.uuid })),
            shouldShowBuySingleFileActions && (React.createElement(CardActions, { classes: { root: classes.cardActions } },
                doQualifyForDigitalRebate && (React.createElement("div", { className: classes.singleFilePriceContainer },
                    React.createElement("div", { className: classes.oldPrice }, formatCurrency(singleFileProduct.productprices[0].price)),
                    React.createElement("div", { className: classes.currentPrice },
                        " ",
                        formatCurrency(rebatedFilePrice)))),
                !doQualifyForDigitalRebate && !hasCampaignPrice && (React.createElement("div", { className: classes.singleFilePriceContainer },
                    React.createElement("div", { className: classes.currentPrice }, formatCurrency(picture.inCart
                        ? getProductPriceByProductAndBoughtPictures(singleFileProduct, picture, boughtImagesOfType, getPricePerUnit)
                        : priceWithOneMoreItem)))),
                !doQualifyForDigitalRebate && hasCampaignPrice && (React.createElement("div", { className: classes.singleFilePriceContainer },
                    React.createElement("div", { className: classes.oldPrice }, formatCurrency(picture.inCart
                        ? getProductPriceByProductAndBoughtPictures(singleFileProduct, picture, boughtImagesOfType, getPricePerUnit, true)
                        : priceWithOneMoreItem)),
                    React.createElement("div", { className: classes.currentPrice },
                        " ",
                        formatCurrency(picture.inCart
                            ? getProductPriceByProductAndBoughtPictures(singleFileProduct, picture, boughtImagesOfType, getPricePerUnit)
                            : priceWithOneMoreCampaignItem)))),
                singleFileProduct && pictureSetInCart && (React.createElement(Button, { color: "primary", disabled: true },
                    React.createElement(Trans, null, "Picture set in cart"))),
                singleFileProduct && !pictureSetInCart && !picture.inCart && (React.createElement(Button, { color: "primary", variant: "contained", onClick: () => toggleFileInCart(picture) },
                    React.createElement(Trans, null, "Buy digital file"))),
                singleFileProduct && !pictureSetInCart && picture.inCart && (React.createElement(Button, { color: "primary", variant: "outlined", onClick: () => toggleFileInCart(picture) },
                    React.createElement(Trans, null, "Remove from cart")))))));
    })));
}
const getProductPriceByProductAndBoughtPictures = (product, picture, pictureList, getPricePerUnit, disableCampaign = false) => {
    console.log("And bought", product, picture, product.productprices[0].campaignprice);
    if (product.productprices[0].type == 0) {
        console.log("Yey!!!");
        return getPricePerUnit(product, pictureList.length, !!(!disableCampaign && product.productprices[0].campaignprice));
    }
    const index = pictureList.findIndex((p) => p.uuid === picture.uuid);
    if (index < 0) {
        // Fixme: Should never happen?
        return product.productprices[0].price;
    }
    let lastProductPrice = product.productprices[0].price;
    for (const productPrice of product.productprices) {
        if (productPrice.quantity > index + 1) {
            break;
        }
        lastProductPrice = productPrice.price;
    }
    return lastProductPrice;
};
export default PictureSetPictures;
